import React, {useEffect, useState} from 'react';
import './DashboardItems.scss';
import {FileDownload, ListIcon, VisitIcon} from "../DashboardTypeSVG/DashboardTypeSVG";
import {useNavigate} from "react-router-dom";

const TrackingItemBox = ({data}) => {

  const navigateTo = useNavigate();
  const [currentTab, setCurrentTab] = useState(1);
  const [componentData, setComponentData] = useState([]);

  useEffect(() => {
    if (currentTab === 1) {
      setComponentData(data?.followMeData)
    } else {
      setComponentData(data?.trackingBoxData)
    }
  }, [currentTab]);

  try {
    return (
      <div className="trackingItemBox box-sec">
        <div className={"row-tab-change"}>
          <h6 onClick={() => setCurrentTab(1)}
              style={currentTab === 1 ? {backgroundColor: "#FFBD35"} : {backgroundColor: "#FFFFFF"}}>صندوق پیگیری</h6>
          <h6 onClick={() => setCurrentTab(2)}
              style={currentTab === 2 ? {backgroundColor: "#FFBD35"} : {backgroundColor: "#FFFFFF"}}> پیگیری من</h6>
        </div>
        <div className={"current-box-tracking"}>
          <div className={"head-table"}>
            <h6 style={{width: "10%"}}>کد پیگیری</h6>
            <h6 style={{width: "20%"}}>نام فهرست</h6>
            <h6 style={{width: "20%"}}>ارجاع به</h6>
            <h6 style={{width: "20%"}}>تاریخ و ساعت</h6>
            <h6 style={{width: "20%"}}>شرح</h6>
            <h6 style={{width: "10%"}}>فایل</h6>
            <h6 style={{width: "10%"}}>عملیات</h6>
          </div>
          <ul>
            {componentData?.length > 0 && componentData?.map((item, index) =>
              <li key={"row" + index}>
                <h6 style={{width: "10%"}}>{item?.trackingCode}</h6>
                <h6 style={{width: "20%"}}>{item?.list}</h6>
                <h6 style={{width: "20%"}}>{item?.userDestination}</h6>
                <h6 style={{width: "20%"}}>{item?.dateTime}</h6>
                <h6 style={{width: "20%"}}>{item?.description}</h6>
                <h6 style={{width: "10%"}}>
                  {item?.file === "" ? "-" : <a href={item?.file} target={"_blank"}><FileDownload/></a>}
                </h6>
                <h6 style={{width: "10%", display: "flex", columnGap: "10px"}}>
                  <div style={{cursor: "pointer"}} onClick={() => navigateTo("/FollowUpList",
                    {state: {pkValue: item.primaryKey, listName: item.listname}})}><VisitIcon/></div>
                  <div style={{cursor: "pointer"}} onClick={() => navigateTo(item.destination, {
                    state: {title: item.title, primaryKeyFilter: item.primaryKey}
                  })}><ListIcon/></div>
                </h6>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default TrackingItemBox;